// theme constant
export const gridSpacing = 3;
//vijay - customize menu width 260
export const drawerWidth = 260;
export const drawerWidthCollapse = 60;
export const appDrawerWidth = 320;
